import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { CollectionFilter } from "../../models/CollectionFilter";
import DashboardFilter from "../DashboardFilter/DashboardFilter.vue";
import {
  FilterField,
  FilterOfCollection
} from "../../models/FilterOfCollection";
import store from "@/store";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  DASHBOARD_CHART_TYPES,
  GENERAL_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { mapGetters } from "vuex";
import lodash from "lodash";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { Field } from "../../models/Field";
import { SectionOfDashboard } from "../../models/SectionOfDashboard";
import { FilterItemOfQuery } from "../../models/FilterItemOfQuery";
import { GroupFields } from "../../models/GroupFields";
import { BqDashboardService } from "../../services/BqDashboardService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import Charts from "../Charts/Charts.vue";
import { DASHBOARD_MESSAGES } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { Http } from "@status/codes";
import ChartTypeMenu from "../ChartTypeMenu/ChartTypeMenu.vue";
import {
  DASHBOARD_TEMPLATE_EVENTS,
  DASHBOARD_TEMPLATE_MESSAGES,
  DATA_TYPE,
  SEE_BY_LIST
} from "../../constants/DashboardTemplatesConstants";

@Component({
  name: "CollectionOfSection",
  components: {
    DynamicSelect,
    DashboardFilter,
    Charts,
    EmptyState,
    ChartTypeMenu
  },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard"
    })
  }
})
export default class CollectionOfSection extends Vue {
  @Inject() bqDashboardService!: BqDashboardService;
  @Prop() indexCollectionFilter!: number;
  @Prop() indexSectionOfDashboard!: number;
  @Prop() collectionFilter!: CollectionFilter;
  @Prop() collectionsOptions!: { id: string; name: string; fields?: Field[] }[];
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;

  filters: FilterOfCollection[] = [];
  collectionField = [] as DynamicSelectData[];
  collectionsOptionsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    required: true,
    hideDetails: false
  };
  configChartForm = false;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  addItem = GENERAL_CONSTANTS.ICONS.ADD;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  chartOptions = {};
  showDialogConfigChart = false;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  EMPTY_STATE_HEADER = DASHBOARD_MESSAGES.NO_RESULTS;
  EMPTY_STATE_PARAGRAPH = DASHBOARD_MESSAGES.NOT_FOUND;
  groupBy = [] as DynamicSelectData[];
  groupByOptionsConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: DASHBOARD_TEMPLATE_MESSAGES.GROUP_BY,
    hideDetails: false,
    attach: false,
    limit: 3,
    required: true
  };
  seeBy = [] as DynamicSelectData[];
  seeByOptionsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: lodash.cloneDeep(SEE_BY_LIST),
    filled: false,
    messageLabel: DASHBOARD_TEMPLATE_MESSAGES.SEE_BY,
    hideDetails: false,
    attach: false,
    required: true
  };
  chartName = "";
  showCharts = false;
  firstQueryExecuted = false;
  propertiesToChart = {};
  foundData = true;
  showSeeBy = false;
  searching = false;
  chartType = "";
  reloadChartTypeMenu = 0;
  chartColor = { hex: "" };
  mounted() {
    this.preloadData();
  }
  preloadData() {
    const collectionFilter = lodash.cloneDeep(
      this.sectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
        this.indexCollectionFilter
      ]
    );
    this.collectionField = collectionFilter.collection;
    this.collectionsOptionsConfig.listAll = lodash.cloneDeep(
      this.collectionsOptions
    );
    this.chartName = collectionFilter.chartName;
    this.filters = this.collectionFilter.filters;
    this.chartColor = { hex: collectionFilter.chartColor as string };

    this.chartType = collectionFilter.chartType;

    this.groupByOptionsConfig.listAll = this.collectionsOptions
      .find(collection => collection.id == collectionFilter.collection[0].id)
      ?.fields!?.map(item => {
        return { id: item.field, name: item.visualField, type: item.type };
      }) as DynamicSelectData[];

    if (collectionFilter.filters.length == 0) {
      return;
    }

    this.groupBy = this.groupByOptionsConfig.listAll?.filter(option =>
      (collectionFilter.groupBy as string[]).includes(option.id)
    );

    this.seeBy = this.seeByOptionsConfig.listAll?.filter(
      option => option.id == (collectionFilter.seeBy as DynamicSelectData).id
    );

    this.makeQuery(true);
  }

  @Watch("collectionsOptions")
  onCollectionsOptionsChange() {
    this.collectionField = lodash.cloneDeep(this.collectionFilter.collection);

    if (this.collectionField.length > 0) {
      this.collectionsOptionsConfig.listAll = lodash
        .cloneDeep(this.collectionsOptions)
        .concat(this.collectionField[0]);
      return;
    }

    this.collectionsOptionsConfig.listAll = lodash.cloneDeep(
      this.collectionsOptions
    );
  }

  @Watch("collectionFilter", { deep: true })
  onCollectionFilterChange() {
    this.filters = this.collectionFilter.filters;
    this.collectionField = lodash.cloneDeep(this.collectionFilter.collection);
  }

  onCollectionFieldChange() {
    store.commit(
      DASHBOARD_TEMPLATE_EVENTS.QUITE_COLLECTION_ITEM_OPTION_AND_PUT_IN_COLLECTION,
      {
        indexSectionOfDashboard: this.indexSectionOfDashboard,
        indexCollectionFilter: this.indexCollectionFilter,
        collection: this.collectionField
      }
    );
    this.groupByOptions();
  }

  saveConfigChart() {
    if (this.validateGroupBy()) {
      return Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.CANT_GROUP_BY_DATE);
    }
    this.showDialogConfigChart = false;
    this.makeQuery();
  }

  validateGroupBy() {
    return (
      this.groupBy.filter(groupBy => groupBy.type == DATA_TYPE.TIME_STAMP)
        .length == 2
    );
  }

  addFilter() {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.ADD_FILTER, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      index: this.indexCollectionFilter,
      onefilter: { field: [], operator: [], value: [] }
    });
  }

  deleteCollection() {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.DELETE_COLLECTION, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      index: this.indexCollectionFilter
    });

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_COLLECTION_ITEM, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      collection: this.collectionField[0]
    });
  }

  sendDataToStoreReadyToChart(xAxis: [], data: [], groups: {}) {
    const chartData = {
      chartName: this.chartName,
      xAxis,
      data,
      groups
    };
    console.log({
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter,
      groupBy: this.groupBy,
      seeBy: this.seeBy,
      chartName: this.chartName,
      chartData,
      chartColor: this.chartColor.hex
    });

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_CONFIG_CHART, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter,
      groupBy: this.groupBy,
      seeBy: this.seeBy,
      chartName: this.chartName,
      chartData,
      chartColor: this.chartColor.hex
    });
  }

  configChart() {
    this.showDialogConfigChart = true;
  }

  groupByOptions() {
    const collection = this.collectionsOptions.find(
      collection => collection.name == this.collectionField[0].name
    );
    if (collection) {
      this.groupByOptionsConfig.listAll = collection.fields?.map(
        (item: Field) => {
          return { id: item.field, name: item.visualField, type: item.type };
        }
      ) as DynamicSelectData[];
    }
  }

  async makeQuery(editMode?: boolean) {
    if (this.groupBy.length == 0) return;

    this.showCharts = false;
    this.firstQueryExecuted = true;

    const filters: FilterItemOfQuery[] = [];
    let groupFields: GroupFields[] = [];

    const collections = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections;

    for (const [indexCollection, collection] of collections.entries()) {
      if (editMode && indexCollection > this.indexCollectionFilter) break;
      collection.filters.forEach(filter => {
        filters.push({
          view: collection.collection[0].id,
          field: (filter.field[0] as FilterField).id,
          operator: ((filter.operator[0] as unknown) as DynamicSelectData).id,
          value: this.fixValues(filter)
        });
      });
      if (
        collection.collection[0].name == this.collectionField[0].name &&
        this.groupBy.length > 0
      ) {
        groupFields = this.groupBy
          .sort((a, b) =>
            a.type === DATA_TYPE.TIME_STAMP && b.type !== DATA_TYPE.TIME_STAMP
              ? -1
              : a.type !== DATA_TYPE.TIME_STAMP &&
                b.type === DATA_TYPE.TIME_STAMP
              ? 1
              : 0
          )
          .map(groupBy => ({
            view: collection.collection[0].id,
            field: (groupBy as DynamicSelectData).id
          }));
      }
    }

    const query = {
      selectFields: {
        fields: [],
        agregations: []
      },
      seeBy: "",
      principalView: this.sectionsOfDashboardStore[this.indexSectionOfDashboard]
        .collections[0].collection[0].id,
      filters: filters,
      groupFields: groupFields
    };

    if (this.seeBy.length > 0) {
      query.seeBy = this.seeBy[0].id;
    }

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_QUERY, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter,
      query: query
    });

    this.searching = true;
    const dataToChartResponse = await this.bqDashboardService.getDataToChart(
      query
    );
    this.searching = false;

    if (dataToChartResponse.code !== Http.Found) {
      this.foundData = false;
      this.showCharts = false;
      return;
    }
    this.foundData = true;

    this.propertiesToChart = {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter,
      groupBy: this.groupBy,
      chartType: this.chartType,
      chartColor: this.chartColor
    };

    console.log("propertiesToChart", this.propertiesToChart);

    this.onChartTypeChanged(this.chartType);

    this.showCharts = true;
    this.sendDataToStoreReadyToChart(
      dataToChartResponse.data.xAxisValues,
      dataToChartResponse.data.series,
      dataToChartResponse.data.groups
    );
  }

  fixValues(filter: FilterOfCollection) {
    if (["text", "number"].includes((filter.field[0] as FilterField).type)) {
      return [filter.value];
    }
    return filter.value.map(
      (value: DynamicSelectData | string) =>
        (value as DynamicSelectData).id || (value as string)
    );
  }

  @Watch("groupBy")
  onGroupByChange() {
    this.reloadChartTypeMenu++;
    if (
      this.groupBy.filter(groupBy => groupBy.type == DATA_TYPE.TIME_STAMP)
        .length > 0
    ) {
      this.showSeeBy = true;
      return;
    }
    this.showSeeBy = false;
  }

  cancelConfigChart() {
    this.showDialogConfigChart = false;
  }

  onChartTypeChanged(newChartType: string) {
    if (!newChartType) {
      if (this.groupBy.length > 1) {
        newChartType = DASHBOARD_CHART_TYPES.filter(e => e.stacked)[0].value;
      } else {
        newChartType = DASHBOARD_CHART_TYPES.filter(e => !e.stacked)[0].value;
      }
    }
    this.propertiesToChart = {
      ...this.propertiesToChart,
      chartType: newChartType
    };

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_CHART_TYPE, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter,
      chartType: newChartType
    });
  }
}
